module.exports = __webpack_public_path__ + "static/media/bfile-boat.e0d8f12d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-boat.svg
// module id = 171
// module chunks = 0